import { render, staticRenderFns } from "./modal-historico-senioridade.vue?vue&type=template&id=4c6ff1c3&scoped=true"
import script from "./modal-historico-senioridade.ts?vue&type=script&lang=ts&external"
export * from "./modal-historico-senioridade.ts?vue&type=script&lang=ts&external"
import style0 from "./modal-historico-situacao.scss?vue&type=style&index=0&id=4c6ff1c3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6ff1c3",
  null
  
)

export default component.exports